import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "as", "pageType", "slug", "url"];
import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import Link from '../../../atoms/Link';
import { isExternalPage } from '../../../services/pages';
import { AsPropType, LinkPropType } from '../../../services/proptypes';
export default function DropdownMenuItems(_ref) {
  var title = _ref.title,
    options = _ref.options,
    linksAs = _ref.linksAs;
  return /*#__PURE__*/React.createElement(Dropdown, {
    item: true,
    text: title
  }, /*#__PURE__*/React.createElement(Dropdown.Menu, null, options.map(function (_ref2) {
    var linkTitle = _ref2.title,
      as = _ref2.as,
      pageType = _ref2.pageType,
      slug = _ref2.slug,
      url = _ref2.url,
      rest = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: linkTitle
    }, /*#__PURE__*/React.createElement(Link, _extends({
      to: isExternalPage(pageType) ? url : slug,
      linkAs: as || linksAs,
      title: linkTitle,
      internal: !isExternalPage(pageType)
    }, rest)));
  })));
}